import "./LocalSeoConsultantWakefield.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import Principles from "./sections/Principles";
import Consultant from "./sections/Consultant";
import Sectors from "./sections/Sectors";
import Localhero from "./sections/Localhero";
import Localseo from "./sections/Localseo";
import Process from "./sections/Process";
import Faq from "./sections/Faq";
import Wakefield from "./sections/Wakefield";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantWakefieldPage() {
  return <div>
      <Header />
      <Consultation />
      <Casestudyshowcase />
      <Principles />
      <Consultant />
      <Sectors />
      <Localhero />
      <Localseo />
      <Process />
      <Faq />
      <Wakefield />
      <Footer />
    </div>;
}